import { useRef } from "react";
import { useReducedMotion } from "./reducedMotion";
import { useScrollFrame } from "./scrollFrame";
import { truncateNumber } from "src/domains/shared/utils/truncateNumber";

/** 위로 빠져나가는 동안 남기는 최소 투명도·올라가는 거리(시안 `data-fadeout`) */
const MIN_OPACITY_LOSS = 0.85;
const RISE_PX = 36;
const LEAVE_FRACTION = 0.9;

/**
 * 첫머리 글이 화면 위로 빠져나가는 동안 옅어지며 살짝 올라간다. 값은 스크롤 프레임마다 DOM 에 직접 쓴다.
 * 움직임 줄이기면 아무것도 하지 않는다.
 */
export function useFadeOutOnLeave<T extends HTMLElement>() {
  const elementRef = useRef<T>(null);
  const reducedMotion = useReducedMotion();
  useScrollFrame(() => {
    const element = elementRef.current;
    if (!element) return;
    const rect = element.getBoundingClientRect();
    const progress = Math.min(
      1,
      Math.max(0, -rect.top / (rect.height * LEAVE_FRACTION))
    );
    element.style.opacity = truncateNumber(1 - progress * MIN_OPACITY_LOSS, 3);
    element.style.transform = progress
      ? `translate3d(0,${truncateNumber(-progress * RISE_PX, 1)}px,0)`
      : "";
  }, !reducedMotion);
  return elementRef;
}
